/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import { useTranslation } from 'next-i18next'
import { Box } from '@mui/material'
import { EmtIcon, EmtTypography } from 'emt-components-v2'
import { Progress } from '../Progress'
import { LightBox } from '../../Profile/partials/StyledComponents'

interface BadgeIcon {
  '@type': string
  '@id': string
  type: string
  value: string
  color: string
}

interface BadgeLabel {
  '@type': string
  '@id': string
  label: string
  color: string
  icon: string
}

interface PsychologyBadge {
  '@type': string
  '@id': string
  color: string
  description: string
  icon: BadgeIcon
  label: BadgeLabel
  plainWidth: boolean
}

interface PetLovingBadge {
  '@type': string
  '@id': string
  position: number
  title: string
  description: string
  plainWidth: boolean
}

interface PetsitterPetLoving {
  '@type': string
  '@id': string
  psychologyBadge: PsychologyBadge
  petLovingBadges: PetLovingBadge[]
}

type Props = {
  petsitterPetLoving: PetsitterPetLoving
  name: string
}

export const Love: React.FC<Props> = ({ petsitterPetLoving, name }) => {
  const { t } = useTranslation('petsitter')
  const { psychologyBadge, petLovingBadges } = petsitterPetLoving

  const colorMap: { [key: string]: string } = {
    pink: '#C80068',
    blue: '#0030CC',
    // Add more colors if needed
  }

  const progressValue = Number(psychologyBadge.icon.value)
  const progressColor = colorMap[psychologyBadge.icon.color] || psychologyBadge.icon.color

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <EmtTypography variant="h4" fontWeight={800}>
        {t('profile.love.title', { name: name })}
      </EmtTypography>
      <LightBox sx={{ minHeight: 'unset', padding: '16px', borderColor: '#F4CCE1', backgroundColor: '#FFE6F380' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
          <Progress value={progressValue} color={progressColor} />
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px', color: '#C80068' }}>
              <EmtIcon className={psychologyBadge?.label.icon} sx={{ fontWeight: 100, fontSize: '14px!important' }} />
              <EmtTypography variant="body1" fontWeight="700" fontSize="18px">
                Psychologie certifiée
              </EmtTypography>
            </Box>
            <EmtTypography variant="body2">{psychologyBadge.description}</EmtTypography>
          </Box>
        </Box>
      </LightBox>
      {petLovingBadges.map((badge, index) => (
        <LightBox key={index} sx={{ minHeight: 'unset', padding: '27px', borderColor: '#E8E8EA' }}>
          <EmtTypography variant="body1" fontWeight="700" fontSize="18px">
            {badge.title}
          </EmtTypography>
          <EmtTypography variant="body1">{badge.description}</EmtTypography>
        </LightBox>
      ))}
    </Box>
  )
}
